"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidEnhancement = exports.State = void 0;
const effect_1 = require("effect");
const _util_1 = require("../_util");
const Definition = __importStar(require("../common"));
const Enhancement = __importStar(require("../enhancement"));
const Catalogue = __importStar(require("./catalogue"));
const NAMESPACE = 'Culligan.Device.Capability.Consumable.Definition.LiquidEnhancement';
const TAG = 'LiquidEnhancement';
const LABEL = 'Liquid Enhancement';
exports.State = Definition.BaseState.pipe(effect_1.Schema.extend(Definition.DepletableState), effect_1.Schema.extend(Definition.ExpirableState), effect_1.Schema.extend(Definition.BatchState)).annotations({
    identifier: `${NAMESPACE}.State`,
    title: `${LABEL} State`,
});
class LiquidEnhancement extends Definition.DepletableInLiters.extend(`${NAMESPACE}.${TAG}`)({ _tag: effect_1.Schema.tag(TAG), ...Enhancement.DefinitionFields }, {
    identifier: `${NAMESPACE}.${TAG}`,
    title: LABEL,
}) {
    static id = 'liquid_enhancement';
    static label = LABEL;
    static category = Definition.Category.Enhancements;
    static expirable = true;
    static hasBatch = true;
    static State = exports.State;
    get mixRatios() {
        return Enhancement.getMixRatios(this.nominalMixRatio, this.mixRatioScalars);
    }
    /**
     * The reason for this funny syntax is a circular dependency at runtime between
     * this module and the modules within the `catalogue` directory. Instead,
     * we only import the `LiquidEnhancement` type within the `catalogue` directory
     * and perform the decoding within this module.
     */
    static catalogue = (0, effect_1.pipe)({
        caffeine: Catalogue.Caffeine.default,
        cherry_lime: Catalogue.CherryLime.default,
        cucu: Catalogue.Cucumber.default,
        electrolytes: Catalogue.Electrolytes.default,
        immunity: Catalogue.Immunity.default,
        lemon: Catalogue.Lemon.default,
        mixed_berry: Catalogue.MixedBerry.default,
        peach_mango: Catalogue.PeachMango.default,
        pineapple_strawberry: Catalogue.PineappleStrawberry.default,
        pom_blu: Catalogue.PomegranateBlueberry.default,
        stevia: Catalogue.Sweetener.default,
        watermelon: Catalogue.Watermelon.default,
        cucumber_uk: Catalogue.CucumberUk.default,
        mixed_berry_uk: Catalogue.MixedBerryUk.default,
        peach_mango_uk: Catalogue.PeachMangoUk.default,
        sweetener_uk: Catalogue.SweetenerUk.default,
        watermelon_uk: Catalogue.WatermelonUk.default,
    }, effect_1.Record.map(consumable => effect_1.Schema.decodeSync(this)(consumable)));
    static legacyCatalogueItemIdMap = {
        cucumber: 'cucu',
        sweetener: 'stevia',
        pomegranate_blueberry: 'pom_blu',
        energy: 'caffeine',
        mixed_berries: 'mixed_berry',
        lemon2: 'lemon',
        peach2: 'peach_mango',
        peach_mango2: 'peach_mango',
    };
    static twistUsaOnlyCatalogueItemIds = [
        'caffeine',
        'cherry_lime',
        'cucu',
        'electrolytes',
        'immunity',
        'lemon',
        'mixed_berry',
        'peach_mango',
        'pineapple_strawberry',
        'pom_blu',
        'stevia',
        'watermelon',
    ];
    /**
     * These `LiquidEnhancement`s were formulated specifically for the EMEA market.
     * We don't want these items to be exposed in the catalogue of Twist devices in the USA,
     * as this would make them accidentally selectable through the "Manual Entry" BiB check-in flow.
     * Twist firmware v3.0.0 has logic to conditionally expose catalogue items
     * based on the commissioning code used, but this logic is not present in prior firmware version.
     * As a result, we exclude these specific IDs on the Twist catalogue HTTP endpoints.
     *
     * See: https://culligan.atlassian.net/browse/IOTPE-928
     */
    static twistEmeaOnlyCatalogueItemIds = [
        'cucumber_uk',
        'mixed_berry_uk',
        'peach_mango_uk',
        'sweetener_uk',
        'watermelon_uk',
    ];
    static CatalogueItemFromId = (0, _util_1.makeCatalogueItemFromId)(this).annotations({
        identifier: `${NAMESPACE}.CatalogueItemFromId`,
    });
}
exports.LiquidEnhancement = LiquidEnhancement;
Definition.satisfiesConstructor(LiquidEnhancement);
//# sourceMappingURL=index.js.map